import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import type { AppDispatch, RootState } from './store'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useWorkingAddress = () => {
  return useAppSelector((state) => state.auth.workingAddress)
}

export const useCurrentSite = () => {
  return useAppSelector((state) => state.auth.currentSite)
}
